module.exports = __webpack_public_path__ + "static/media/10.Slab-Shuttering-Arrangement.a1f2531f.webp";